
// Define the openTaby function separately
function openTaby(evt, cityName) {
  var i, tabcontenty, tablinksy;
  tabcontenty = document.getElementsByClassName("tabcontent-cusy");
  for (i = 0; i < tabcontenty.length; i++) {
    tabcontenty[i].style.display = "none";
  }
  tablinksy = document.getElementsByClassName("tablinks-cusy");
  for (i = 0; i < tablinksy.length; i++) {
    tablinksy[i].className = tablinksy[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Use DOMContentLoaded event listener for operations that should occur after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // If you need to trigger the openTaby function when the DOM is loaded, you can do it here
  var initialTabElement = document.getElementById("tab-cus-activee");
  if (initialTabElement) {
    initialTabElement.click(); // Simulate a click on the initial tab
  } else {
    console.log('Element with ID "tab-cus-activee" not found');
  }
});
